import { CheckCircleRounded } from '@material-ui/icons';
import { useMediaQuery, Theme } from '@material-ui/core';
import { FC } from 'react';
import { publicVideoPath } from '@orientaction/utils';
import { useMediaPanelStyles } from './MediaPanel.styles';

const MEDIA_ITEMS = [
  'Tests de personnalité gratuits',
  'Retrouvez tous vos résultats',
  'Passez nos nouveaux tests',
  'Partagez nos tests avec vos proches',
];

const QUOTE =
  "« Il y a trois choses extrêmement dures : l'acier, le diamant et se connaître soi-même » Benjamin Franklin";

export const MediaPanel: FC = () => {
  const cls = useMediaPanelStyles();
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

  return (
    <div className={cls.mediaPanel}>
      <video
        poster="poster.JPG"
        playsInline={true}
        autoPlay={true}
        muted={true}
        loop={true}
        className={cls.video}>
        <source src={`${publicVideoPath}/orientaction.m4v`} type="video/mp4" />
      </video>
      <div className={cls.videoOverlay} />
      <div className={cls.mediaContent}>
        {!isMobile && <span className={cls.mediaTitle}>{QUOTE}</span>}
        <span className={cls.mediaSubtitle}>
          Obtenez une description complète de qui vous êtes pour faire les bons choix dans la vie
        </span>
        <ul className={cls.mediaList}>
          {MEDIA_ITEMS.map(item => (
            <li key={item} className={cls.mediaListItem}>
              <CheckCircleRounded className={cls.mediaCheckIcon} />
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
